const TOKEN_KEY = 'avalanche.session_token';

export function getToken() {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    // Safari private mode and similar can throw on localStorage access.
    return null;
  }
}

export function setToken(token) {
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Nothing useful to do; the session simply won't survive a reload.
  }
}

export function clearToken() {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    // See setToken.
  }
}

// Reads the payload of the Avalanche session JWT minted by
// backend/authorization/utils.py:create_session_token. The signature is not
// verified here - the backend is the only authority on that. We only need the
// `exp` claim so we can refresh before the token goes stale.
export function decodeJwt(token) {
  if (!token) {
    return null;
  }
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(escape(window.atob(base64))));
  } catch {
    return null;
  }
}

export function expiresAt(token) {
  const payload = decodeJwt(token);
  return payload?.exp ? payload.exp * 1000 : null;
}

// `skewSecs` lets callers treat a soon-to-expire token as already expired so a
// request in flight cannot outlive it.
export function isExpired(token, skewSecs = 0) {
  const expiry = expiresAt(token);
  if (!expiry) {
    return true;
  }
  return Date.now() >= expiry - skewSecs * 1000;
}
